import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=a16b91d4&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=js&"
export * from "./Hero.vue?vue&type=script&lang=js&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=a16b91d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b91d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StrapiImage: require('/vercel/path0/components/StrapiImage.vue').default,Animation: require('/vercel/path0/components/Animation.vue').default})
